import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { adminApi } from "../../../lib/adminApi";
import { Card, TextInput, Btn, run } from "../AdminUI";

const FIELDS = [["company", "Carrier company"], ["mc_number", "Carrier MC #"], ["driver_name", "Driver name"], ["driver_phone", "Driver phone"], ["truck_info", "Truck info"], ["trailer_info", "Trailer info"]];

export const CarrierTab = ({ sh, apply }) => {
  const [f, setF] = useState(() => ({ ...Object.fromEntries(FIELDS.map(([k]) => [k, ""])), ...(sh.carrier || {}) }));
  const save = async () => {
    const carrier = Object.fromEntries(Object.entries(f).map(([k, v]) => [k, v?.trim() ? v.trim() : null]));
    const r = await run(() => adminApi.patch(`/admin/shipments/${sh.tracking_number}`, { carrier }), "Carrier saved");
    if (r) apply(r.data);
  };
  return (
    <Card title="Carrier & driver" testid="carrier-tab" actions={<span className="inline-flex items-center gap-1.5 text-xs text-slate-500"><ShieldAlert className="w-3.5 h-3.5" />Private, never shown publicly</span>}>
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, l]) => <TextInput key={k} label={l} value={f[k]} onChange={(v) => setF((p) => ({ ...p, [k]: v }))} testid={`carrier-${k.replace(/_/g, "-")}`} />)}
      </div>
      {!sh.payment_gate_ok && <p className="mt-4 text-xs text-amber-800 bg-amber-50 border border-amber-200 px-3 py-2" data-testid="carrier-gate-warning">You can save carrier details now, but the status cannot move to Carrier Booked until payment is confirmed or COD is agreed.</p>}
      <div className="mt-5 flex justify-end"><Btn onClick={save} data-testid="carrier-save">Save carrier</Btn></div>
    </Card>
  );
};
